/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSavePeriodGradeDto } from '../../models/amoxcalli-save-period-grade-dto';

export interface ApiGradesPeriodReportGet$Json$Params {
  cycleSubjectIds?: Array<string>;
}

export function apiGradesPeriodReportGet$Json(http: HttpClient, rootUrl: string, params?: ApiGradesPeriodReportGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliSavePeriodGradeDto>>> {
  const rb = new RequestBuilder(rootUrl, apiGradesPeriodReportGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleSubjectIds', params.cycleSubjectIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliSavePeriodGradeDto>>;
    })
  );
}

apiGradesPeriodReportGet$Json.PATH = '/api/grades/period/report';
